module.exports = global["jQuery"] = require("-!/home/mpds-metd/galaxy19/galaxy/client/node_modules/expose-loader/index.js?$!./jquery.custom.js");